import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { apiUrlInterceptor } from './api-url.interceptor';
import { authInterceptor } from './auth.interceptor';
import { unauthorizedInterceptor } from './unauthorized.interceptor';

/** HttpClient + redeemee-node interceptors (base URL, JWT, 401 handling). */
export function provideRedeemeeHttp() {
  return provideHttpClient(
    withInterceptors([apiUrlInterceptor, authInterceptor, unauthorizedInterceptor]),
  );
}
